import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from "@/mobile/common/LoadingSpinner";
import {getPlatform} from "@/hooks";
import { useTranslation } from 'react-i18next';

const { UI } = Mobi2Go;

const RequirePassword = ({
    baseClass,
    isRefreshing,
    handleChange,
    password,
    promptText,
    savingText,
    policyLink,
    isSuccess,
    closeModal,
    onKeyDown = () => {}
 }) => {
    const [t] = useTranslation('customer');

    const onPolicyLinkClick = () => {
        closeModal();
        UI.trigger('showPolicy', 'loyalty');
    }

    if (getPlatform() === 'web') {
        return (
            <>
                <div
                    className={baseClass('-password-prompt-container')}
                >
                    <label
                        htmlFor="password"
                        className={baseClass('-password-prompt m2g-text--small')}
                    >
                        {!isRefreshing ?
                            promptText
                            :
                            savingText
                        }

                        {!isRefreshing &&
                            policyLink &&
                            <a
                                className={baseClass('-password-prompt__link')}
                                onClick={onPolicyLinkClick}
                            >
                                {policyLink}
                            </a>
                        }

                        {isSuccess &&
                            t('loyalty:opt_in_success')
                        }
                    </label>
                </div>
                <div
                    className={baseClass('-password m2g-input-container')}
                    data-icon-before
                >
                    <input
                        type="password"
                        value={password}
                        placeholder={t('customer:login_password_placeholder')}
                        id="password"
                        className={baseClass('-password-input m2g-input')}
                        onChange={(e) => handleChange(e.target.value)}
                        disabled={isRefreshing}
                        onKeyDown={onKeyDown}
                    />
                    <span className="m2g-icon m2g-icon--padlock" />

                    {isRefreshing && (
                        <div
                            className={baseClass('-loading-indicator-container')}
                        >
                            <div
                                className={baseClass(
                                    '-loading-indicator m2g-icon m2g-icon--spinner m2g-icon--small'
                                )}
                            />
                        </div>
                    )}

                </div>
            </>
        );
    }

    return (
        <>
            <div
                className={baseClass('-password-prompt-container')}
            >
                <label
                    htmlFor="password"
                    className={baseClass('-password-prompt')}
                >
                    {!isRefreshing ?
                        promptText
                        :
                        savingText
                    }

                    {!isRefreshing &&
                        policyLink &&
                        <a
                            className={baseClass('-password-prompt__link m2g-touchable')}
                            onClick={() => UI.trigger('showPolicy', 'loyalty')}
                        >
                            {policyLink}
                        </a>
                    }

                    {isSuccess &&
                        t('loyalty:opt_in_success')
                    }
                </label>
            </div>
            <div
                className={baseClass('-password m2g-list-cell')}
                data-icon-before
            >
                <span className="m2g-icon m2g-list-cell__icon m2g-icon--padlock" />
                <input
                    type="password"
                    value={password}
                    placeholder={t('customer:login_password_placeholder')}
                    id="password"
                    className={baseClass('-password-input m2g-list-cell__content m2g-touchable')}
                    onChange={(e) => handleChange(e.target.value)}
                    disabled={isRefreshing}
                    onKeyDown={onKeyDown}
                />

                {isRefreshing &&
                    <LoadingSpinner className={baseClass('-spinner m2g-list-cell__icon m2g-list-cell__icon--right')} />
                }
            </div>
        </>
    );
}

RequirePassword.propTypes = {
    baseClass: PropTypes.func.isRequired,
    isRefreshing: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    password: PropTypes.string.isRequired,
    promptText: PropTypes.string.isRequired,
    savingText: PropTypes.string.isRequired,
    policyLink: PropTypes.string,
    isSuccess: PropTypes.bool,
    closeModal: PropTypes.func,
};

RequirePassword.defaultProps = {
    policyLink: '',
    isSuccess: false,
    closeModal: () => {},
};

export default RequirePassword;
